<section class="alert" [ngClass]="['alert--' + status]" role="alert">
  <div class="alert__icon" *ngIf="showDefaultIcon"><fstr-icon [anchor]="'icon-alert-' + status"></fstr-icon></div>
  <main class="alert__content">
    <div class="type-body-xxs" [innerHTML]="message"></div>
    <ng-content></ng-content>
  </main>
</section>
